module.exports = function() {
  return new Worker(__webpack_public_path__ + "c5ee055fa6a2f4921aa4.worker.js");
};